import React, { useEffect } from 'react'

import Tracker from '@openreplay/tracker'

interface OpenReplayProviderProps {
    children: React.ReactNode
}

export const OpenReplayProvider: React.FC<OpenReplayProviderProps> = ({ children }) => {
    useEffect(() => {
        // Only initialize in production environments
        if (process.env.REACT_APP_ENV === 'production') {
            const tracker = new Tracker({
                projectKey: 'XA6UQC6MwPC45igkGJM7',
                ingestPoint: 'https://openreplay.mach.exchange/ingest',
            })

            // Start the tracker
            tracker.start()
        }
    }, [])

    return <>{children}</>
}

export default OpenReplayProvider
